import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy-policy" element={<LegalPage slug="privacy" />} />
                    <Route path="/terms-and-conditions" element={<LegalPage slug="terms" />} />
                    <Route path="/cookie-policy" element={<LegalPage slug="cookies" />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Toaster position="bottom-right" />
            </BrowserRouter>
        </div>
    );
}

export default App;
